import { render, staticRenderFns } from "./activityTemplate.vue?vue&type=template&id=29960624"
import script from "./activityTemplate.vue?vue&type=script&lang=js"
export * from "./activityTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports